export const GAME_MODE = {
    MAIN: 'main',
    BONUS: 'bonus'
}

export const FEATURE_TYPES = {
    BONUS_1: 'bonus_1',
    BONUS_2: 'bonus_2'
}
